import { useLingui } from '@lingui/react/macro';

export const DENTITION_PERMANENT = 'permanent';
export const DENTITION_PRIMARY = 'primary';
export const DENTITION_MIXED = 'mixed';
export const allDentition = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
];

export const mixedDentitionMap = [
  { primaryTooth: '', permanentTooth: '1' },
  { primaryTooth: '', permanentTooth: '2' },
  { primaryTooth: '', permanentTooth: '3' },
  { primaryTooth: 'A', permanentTooth: '4' },
  { primaryTooth: 'B', permanentTooth: '5' },
  { primaryTooth: 'C', permanentTooth: '6' },
  { primaryTooth: 'D', permanentTooth: '7' },
  { primaryTooth: 'E', permanentTooth: '8' },
  { primaryTooth: 'F', permanentTooth: '9' },
  { primaryTooth: 'G', permanentTooth: '10' },
  { primaryTooth: 'H', permanentTooth: '11' },
  { primaryTooth: 'I', permanentTooth: '12' },
  { primaryTooth: 'J', permanentTooth: '13' },
  { primaryTooth: '', permanentTooth: '14' },
  { primaryTooth: '', permanentTooth: '15' },
  { primaryTooth: '', permanentTooth: '16' },
  { primaryTooth: '', permanentTooth: '17' },
  { primaryTooth: '', permanentTooth: '18' },
  { primaryTooth: '', permanentTooth: '19' },
  { primaryTooth: 'K', permanentTooth: '20' },
  { primaryTooth: 'L', permanentTooth: '21' },
  { primaryTooth: 'M', permanentTooth: '22' },
  { primaryTooth: 'N', permanentTooth: '23' },
  { primaryTooth: 'O', permanentTooth: '24' },
  { primaryTooth: 'P', permanentTooth: '25' },
  { primaryTooth: 'Q', permanentTooth: '26' },
  { primaryTooth: 'R', permanentTooth: '27' },
  { primaryTooth: 'S', permanentTooth: '28' },
  { primaryTooth: 'T', permanentTooth: '29' },
  { primaryTooth: '', permanentTooth: '30' },
  { primaryTooth: '', permanentTooth: '31' },
  { primaryTooth: '', permanentTooth: '32' },
];

export const PAGINATION_IMAGE_COUNT = 4;

export const useSummaryBackgroundContent = () => {
  const { t } = useLingui();

  return {
    background: {
      title: t`What is a VideaHealth Insurance Claim Summary?`,
      body: t`A VideaHealth Insurance claim summary is a document that provides a summary of the findings detected from processing a set of images with VideaAI. It includes details about the findings, how the findings are calculated, and other information that may assist in creating an insurance claim. It is intended to help the communication process between the patient, the dental provider, and the insurance company. It is not a diagnostic or treatment or intended to recommend any diagnosis or treatment.`,
    },
    rbl: {
      title: t`How do we calculate radiographic bone level (RBL)?`,
      body: t`VideaHealth AI measures bone level in bitewings in mm and bone level in periapical radiographs as a ratio (%); both measurements are described below. Radiographic bone level measurements (CEJ to ABL) differ from periodontal charting (gum line to suicus flow), to those two types of bone level measurements will be different on any given tooth.`,
    },
    dmf: {
      title: t`What is Tooth Structure Loss?`,
      body: t`Tooth Structure Loss represents the cumulative percentage of tooth structure lost from dental decay, missing coronal anatomy, and filling/restorative material.`,
    },
    resto: {
      title: t`What are Restorative Imperfections?`,
      body: t`A Restorative Imperfection may include open margins, material voids, marginal leakage, etc. that have the potential to impact the integrity of the restoration.`,
    },
    display: {
      title: t`How do we display clinical values in this summary?`,
      body: t`We display all carious lesions identified by the AI with red boxes. We display RBL withe points and lines to connect the CEJ (cementoenamel junction) and ABL (alveolar bone level). The colors indicate the severity of the the bone level as measured relative to normal (green). In cases where one or both points were not measured, no measurement is shown.`,
    },
  };
};

export const useClaimAttachmentDisclaimer = () => {
  const { t } = useLingui();
  return t`By downloading or using this attachment, you confirm you have reviewed and approved all its contents.`;
};

export type InsuranceView =
  | 'config'
  | 'preview-pages'
  | 'preview-single'
  | 'narrative-dev-tool'
  | 'dev-tool';
